/** @packageDocumentation @internalapi @module path */
export * from './pathNode';
export * from './pathUtils';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/seanopa/PhpstormProjects/courtmenow-app/~/@uirouter/core/lib-esm/path/index.js
// module id = 160
// module chunks = 0